import BannerGeneral from "../components/BannerGeneral";
import BlockBackgroundImage from "../components/BlockBackgroundImage";
import BlockImageCabecera from "../components/BlockImageCabecera";
import useContentful from "../hooks/use-contenful";
import Notification from "../components/Notification";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Breadcumbs from "../components/Breadcumbs";
import { NavLink } from "react-router-dom";
import ConectUs from "../components/ConectUs";
import PosgradoPagos from "../components/PosgradoPagos";
import PosgradoOffer from "../components/PosgradoOffer";
import {
  PosgradoPostulacion,
  PosgradoPostulacionFixed,
} from "../components/Pasos";
import Modal from "../components/Modal";
import HubspotForm from "react-hubspot-form";

const query = `
query 
{
    videoTemplate(id: "41Gw5Tkt6KoUDf7xO36UOH") {
 
      imageBlock1{url}
      contentBlock1{json}
      contentBlock2{json}
      contentBlock3{json}
      contentBlock4{json}
      imageBlock3{url}
      galleryCollection{
        items{url title}
         }

         gallery2Collection{
          items{url title}
           }
    }
}
`;
function Posgrado() {
  let { data, errors } = useContentful(query);

  if (errors)
    return <span>{errors.map((error) => error.message).join(",")}</span>;
  if (!data) return <p>Loading...</p>;

  return (
    <>
      <div className="margin relative">
        <BlockImageCabecera
          src={data.videoTemplate.imageBlock1.url}
          title={
            <>
              {documentToReactComponents(data.videoTemplate.contentBlock1.json)}

              {/*    <div className="margin">
                <a className="button1" href="#descuentos">
                  <span class="material-icons">chevron_right</span>Accede a
                  descuentos y becas
                </a>
              </div> */}
            </>
          }
        ></BlockImageCabecera>
      </div>
      <div className="relative">
        <Notification
          content={
            <>
              {documentToReactComponents(data.videoTemplate.contentBlock2.json)}
              <PosgradoPostulacionFixed></PosgradoPostulacionFixed>
              <div className="flex-center requisitos-posgrados">
                <div>
                  <Modal
                    title="🔍 Revisa el proceso de postulación"
                    content={
                      <>
                        <div>
                          <iframe
                            width="100%"
                            height="400"
                            src="https://www.youtube.com/embed/_olQNX4vBs0?si=Cp_QgVRfGPCJP1A5"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin"
                            allowfullscreen
                          ></iframe>
                        </div>
                      </>
                    }
                  ></Modal>
                </div>
                <div>
                  <Modal
                    title="📝 Revisa el proceso de matrícula"
                    content={
                      <>
                        <div className="width400">
                          <iframe
                            width="100%"
                            height="400"
                            src="https://www.youtube.com/embed/vnzDE0HgLME?si=uQAQHA-B57vC6sbi"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin"
                            allowfullscreen
                          ></iframe>
                        </div>
                      </>
                    }
                  ></Modal>
                </div>
              </div>
            </>
          }
        ></Notification>
      </div>

      <Breadcumbs
        content={
          <>
            <NavLink to="/posgrados">Posgrados</NavLink>
          </>
        }
      ></Breadcumbs>

      <PosgradoOffer
        title={
          <>
            {documentToReactComponents(data.videoTemplate.contentBlock4.json)}
          </>
        }
        subtitle="Elige tu posgrado"
      ></PosgradoOffer>

      <div className="padding">
        <BlockBackgroundImage
          src="https://www.utpl.edu.ec/carreras/sites/default/files/fondo-edes.png"
          content={
            <div>
              <h2>
                Descubre nuestra oferta de posgrados en la
                <b> escuela de negocios EDES</b>
              </h2>
              <a href="/edes">Ver oferta</a>
            </div>
          }
        ></BlockBackgroundImage>
      </div>
      <PosgradoPagos></PosgradoPagos>
      <ConectUs
        lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes de posgrado."
        instagram="https://www.instagram.com/utplposgrados/"
        facebook="https://www.facebook.com/utplposgrados"
      ></ConectUs>
      <BlockBackgroundImage
        src={data.videoTemplate.imageBlock3.url}
        content={documentToReactComponents(
          data.videoTemplate.contentBlock3.json
        )}
      ></BlockBackgroundImage>

      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default Posgrado;
